export default __webpack_public_path__ + "static/Metal_Hatchet-eca44fedd1203f18bc9122c0900ffd73.png";